module.exports = __webpack_public_path__ + "img/arrow-right-square.34aecd58.svg";